import type { UserIdentity } from "ra-core";
import { useGetIdentity } from "ra-core";

type IdentityWithRoles = UserIdentity & {
  administrator?: boolean;
  manager?: boolean;
};

export const isCampaignAdmin = (
  identity?: IdentityWithRoles | null,
) => identity?.administrator === true || identity?.manager === true;

export const useIsCampaignAdmin = () => {
  const { identity } = useGetIdentity();
  return isCampaignAdmin(identity);
};
